import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import ContentIcon, { HEADING_GAMIFICATION } from "ContentIcon";
import NoContent, { NO_GAMIFICATION } from "NoContent";
import { screenHeightLeftFromTop } from "Constants";
import LocaleStrings from "Languages";

class Gamification extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {}

  render() {
    var { deviceSize } = this.props;

    return (
      <div>
        <div className="content-header-bar">
          <div className="pull-left h-100 vertical-align-center">
            <ContentIcon heading={HEADING_GAMIFICATION} />
          </div>
        </div>
        <div className="clearfix"></div>

        <div
          className="panel-body scrollable-content custom-align-center"
          style={{ height: deviceSize.height - screenHeightLeftFromTop }}
        >
          <div>
            <div class="custom-align-center">
              <img
                src="../../style/images/content-icons/content-gamification-Blank.png"
                alt="no-content-icon"
              />
            </div>
            <div class="no-content-message">
              Click on the below button to go to 'Gamification' section to
              manage gamification.
            </div>
            <div className="text-center pt-20">
              <Link to="/dashboard/gamification">
                <button className="btn btn-custom-blue">
                  {LocaleStrings.gamification_clickhere}
                </button>
              </Link>
            </div>
          </div>

          {/* <div className="clearfix">&nbsp;</div> */}
          {/* <NoContent contentType={NO_GAMIFICATION} /> */}
        </div>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    session: state.session,
    deviceSize: state.deviceSize,
  };
}
export default connect(mapStateToProps)(Gamification);
